import { PreviewEntityDTO } from 'common/models/data/entity.model';
import { IndicatorDTO } from 'common/models/data/indicator.model';
import { CategoryErrorVM, PreviewCategoriesVM } from 'common/models/data/previewData.model';

import { ConfigurationIndicatorVM } from 'modules/configuration/models/configuration.model';

export const getSortOrderList = (count: number) =>
    Array.from(Array(count), (el, index) => ({
        label: (index + 1).toString(),
        value: (index + 1).toString()
    }));

export const previewDataMapper = (
    parentId: string,
    categories: PreviewCategoriesVM[],
    categoryErrors: CategoryErrorVM[]
): PreviewEntityDTO[] => {
    return categories.map((cat: PreviewCategoriesVM): PreviewEntityDTO => {
        const catErr = categoryErrors.find((catEr: CategoryErrorVM) => catEr.id === cat.id);
        return {
            parentId: parentId,
            entityType: cat.entityType,
            errors: cat.errors,
            id: cat.id,
            name: cat.name,
            order: cat.order,
            hasChild: cat.hasChild,
            isExpanded: false,
            hasError: catErr?.hasError,
            childHasError: catErr?.childHasError
        };
    });
};

export const previewIndicatorDataMapper = (
    categories: PreviewCategoriesVM[]
): PreviewEntityDTO[] => {
    return categories.map((cat: PreviewCategoriesVM): PreviewEntityDTO => {
        return {
            parentId: '',
            entityType: cat.entityType,
            errors: cat.errors,
            id: cat.id,
            name: cat.name,
            order: cat.order,
            hasChild: cat.hasChild,
            isExpanded: false,
            hasError: cat.errors && cat.errors?.length > 0 ? true : false,
            childHasError: false
        };
    });
};

export const hasValue = (value: any): boolean => {
    if (value !== null && value !== undefined) {
        return true;
    }
    return false;
};

export const hasNoValue = (value: any): boolean => {
    if (value === null || value === undefined) {
        return true;
    }
    return false;
};

export const processNewConfigurationData = (
    data: Array<ConfigurationIndicatorVM>,
    newData: Array<any>
): Array<ConfigurationIndicatorVM> => {
    return [
        ...data,
        ...newData.map((item: any, index: number) => ({
            id: (data.length + index + 1).toString(),
            indicatorId: (data.length + index + 1).toString(),
            name: item.name,
            order: data.length + index + 1,
            path: 'Big Issues > 7 drivers of growth > Customer'
        }))
    ];
};

export const processUpdatedIndicator = (data: any, outputArray: string[], selected: boolean) => {
    data.map((item: any) => {
        const condition = selected ? item?.isSelected : !item?.isSelected;
        if (condition) {
            outputArray.push(item.id);
        }
        if (
            item.subCategories &&
            Array.isArray(item.subCategories) &&
            item.subCategories.length > 0
        ) {
            processUpdatedIndicator(item.subCategories, outputArray, selected);
        }
    });
};

export const getNewlyAddedIndicator = (data: any, indicatorList: string[]) => {
    const outputArray: string[] = [];
    processUpdatedIndicator(data, outputArray, true);
    const newlyAddedIndicator: { indicatorId: string }[] = [];
    outputArray.map((item: any) => {
        if (!indicatorList.includes(item)) {
            newlyAddedIndicator.push({
                indicatorId: item
            });
        }
    });
    return newlyAddedIndicator;
};

export const getRemovedIndicator = (data: any, indicatorList: string[]) => {
    const outputArray: string[] = [];
    processUpdatedIndicator(data, outputArray, false);
    const removedArray = indicatorList.filter((f: any) =>
        outputArray.some((item: any) => item === f)
    );
    const removedIndicator = removedArray.map((item: any) => {
        return {
            indicatorId: item
        };
    });
    return removedIndicator;
};

export const updateIndicatorModel = (indicator: any): IndicatorDTO => {
    return {
        description: !hasNoValue(indicator?.data?.details.description)
            ? indicator?.data?.details.description
            : '',
        name: !hasNoValue(indicator?.data?.details.name) ? indicator?.data?.details.name : '',
        order: !hasNoValue(indicator?.data?.details.order) ? indicator?.data?.details.order : '',
        parentCategoryId: indicator?.data?.details.parentCategoryId,
        reference: !hasNoValue(indicator?.data?.details.reference)
            ? indicator?.data?.details.reference
            : '',
        sortOrder: !hasNoValue(indicator?.data?.details.sortOrder)
            ? indicator?.data?.details.sortOrder
            : '',
        sourceId: !hasNoValue(indicator?.data?.details.sourceId)
            ? indicator?.data?.details.sourceId
            : '',
        frequencyTypeId: !hasNoValue(indicator?.data?.details.frequencyTypeId)
            ? indicator?.data?.details.frequencyTypeId
            : '',
        valueType: !hasNoValue(indicator?.data?.details.valueType)
            ? indicator?.data?.details.valueType
            : '',
        webAddress: !hasNoValue(indicator?.data?.details.sourceId)
            ? indicator?.data?.details.sourceId
            : '',
        sourceDate: !hasNoValue(indicator?.data?.details.sourceDate)
            ? new Date(
                  indicator?.data?.details?.sourceDate ? indicator?.data?.details?.sourceDate : ''
              )
            : undefined
    };
};

export const getSerialNumberedData = (data: any, key: string): any[] => {
    return data.map((item: any, index: number) => ({ ...item, [key]: index + 1 }));
};
